import createReducer from 'utils/redux/createReducer'

const initialState = false

export default createReducer(initialState, {
	CHOOSE_ITEM: (currentState, action) => false
  , SECTION_EXPAND: (currentState, action) => {
      if (!action.data.accordion) return currentState
      return action.data.accordion
  }
  , COMMENTWIZARD_SHOW: (currentState, action) => {
      if (currentState=="commentWizard") return false
      return "commentWizard"
  }

, 'COMMENT_SAVE': (currentState, action) => "group"+action.data.objectID
})



// WEBPACK FOOTER //
// ./src/reducers/accordion.js